(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 8266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(94156);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ OptionalBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const OptionalBadge = (param)=>/*#__PURE__*/ {
    let {} = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "inline-flex items-center mx-0.5 px-1 py-0.5 rounded font-normal text-xs bg-gray-50 text-gray-400",
        children: "optional"
    });
};


/***/ }),

/***/ 32736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ RequiredBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const RequiredBadge = (param)=>/*#__PURE__*/ {
    let {} = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "inline-flex items-center mx-0.5 px-1 py-0.5 rounded font-normal text-xs bg-red-50 text-red-400",
        children: "required"
    });
};


/***/ }),

/***/ 79691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ EmailSubscriptionForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Form_Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27778);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);




const EmailSubscriptionForm = (param)=>{
    let { defaultFields , defaultGroups =[]  } = param;
    const [email, setEmail] = react__WEBPACK_IMPORTED_MODULE_2__.useState(null);
    // form
    const formMethods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI)({
        defaultValues: {
            email: "",
            fields: defaultFields,
            groups: defaultGroups
        }
    });
    const { register , setValue , handleSubmit , formState: { errors , isDirty  } , control  } = formMethods;
    const submit = async (data)=>{
        const response = await fetch("/api/email-subscriptions/subscribe-email-to-groups", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
        const responseJson = await response.json();
        if (responseJson.status === "success") {
            setEmail(data.email);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        onSubmit: handleSubmit(submit),
        children: !email ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-row space-x-1",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_Input__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .I, {
                    path: "email",
                    placeholder: "Email",
                    register: register,
                    errors: errors
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "px-2 py-3 text-xs font-medium text-black bg-gray-200 rounded hover:bg-gray-300",
                    type: "submit",
                    children: "Subscribe"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "",
            children: [
                "Thanks! Go check ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold",
                    children: email
                }),
                " to confirm your subscription."
            ]
        })
    });
};


/***/ }),

/***/ 27778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Badges_OptionalBadge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87881);
/* harmony import */ var _components_Badges_RequiredBadge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32736);
/* harmony import */ var _hookform_error_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32866);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43153);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60487);







const Input = (param)=>{
    let { label , hasOptionalBadge , hasRequiredBadge , path , placeholder , disabled =false , register , registerOptions ={} , type ="text" , errors ={} , labelCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultLabelCN */ .oi , inputCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultInputCN */ .Ln , inputErrorStateCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultInputErrorStateCN */ .pD , errorMessageCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultErrorMessageCN */ .yr , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: path,
                className: labelCN,
                children: [
                    label,
                    " ",
                    hasOptionalBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Badges_OptionalBadge__WEBPACK_IMPORTED_MODULE_1__/* .OptionalBadge */ .E, {}),
                    " ",
                    hasRequiredBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Badges_RequiredBadge__WEBPACK_IMPORTED_MODULE_2__/* .RequiredBadge */ .B, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: type,
                id: path,
                placeholder: placeholder,
                disabled: disabled,
                ...register(path, registerOptions),
                autoComplete: path,
                className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_5__/* .classNames */ .A)(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(errors, path) ? inputErrorStateCN : "", inputCN),
                ...rest
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hookform_error_message__WEBPACK_IMPORTED_MODULE_6__/* .ErrorMessage */ .B, {
                errors: errors,
                name: path,
                render: (param)=>/*#__PURE__*/ {
                    let { message  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: errorMessageCN,
                        children: message
                    });
                }
            })
        ]
    });
};


/***/ }),

/***/ 60487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ defaultSelectErrorStateCN; },
/* harmony export */   "Ln": function() { return /* binding */ defaultInputCN; },
/* harmony export */   "Uh": function() { return /* binding */ defaultDescriptionCN; },
/* harmony export */   "k3": function() { return /* binding */ defaultSelectCN; },
/* harmony export */   "oi": function() { return /* binding */ defaultLabelCN; },
/* harmony export */   "pD": function() { return /* binding */ defaultInputErrorStateCN; },
/* harmony export */   "yr": function() { return /* binding */ defaultErrorMessageCN; }
/* harmony export */ });
/* unused harmony exports defaultInputWithAddonCN, defaultAddonCN */
// Label
const defaultLabelCN = "block mb-1 text-sm font-medium text-gray-700";
// Input
const defaultInputCN = "block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-300 focus:ring-blue-500 focus:border-blue-500";
const defaultInputErrorStateCN = "border-red-500 bg-red-50";
// InputWithAddon
const defaultInputWithAddonCN = "flex-1 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300 placeholder-gray-300 focus:ring-blue-500 focus:border-blue-500";
const defaultAddonCN = "inline-flex px-3 items-center text-gray-500 sm:text-sm rounded-l-md border border-r-0 border-gray-300 bg-gray-50";
// Select
const defaultSelectCN = "block w-full pl-3 pr-10 py-2 text-base border-gray-300 sm:text-sm rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500";
const defaultSelectErrorStateCN = "border-red-500 bg-red-50";
// Description
const defaultDescriptionCN = "pt-1 px-2 text-xs text-gray-600";
// ErrorMessage
const defaultErrorMessageCN = "pt-1 px-2 text-xs text-red-600 rounded-b";


/***/ }),

/***/ 57743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ JobPostsSearchAndResults; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/JobPost/JobPostPreview.tsx + 2 modules
var JobPostPreview = __webpack_require__(87938);
;// CONCATENATED MODULE: ./components/JobPosts/JobPostsSearchAndResults/JobPostsResults/JobPostsList.tsx


const JobPostsList = (param)=>{
    let { jobPosts  } = param;
    return Array.isArray(jobPosts) && jobPosts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "my-4 border-t border-b overflow-hidden divide-y divide-gray-200 sm:border sm:rounded-md ",
        children: jobPosts === null || jobPosts === void 0 ? void 0 : jobPosts.map((jobPost)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostPreview/* JobPostPreview */.n, {
                jobPost: jobPost,
                hasSize: true,
                hasOrganisationAbout: true,
                cN: "px-2 pt-2 pb-4 text-xs sm:px-4 sm:pt-4 sm:pb-6"
            }, jobPost.id))
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto mt-4 mb-10 text-center",
        children: "No results."
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/solid/esm/ChevronDoubleLeftIcon.js


function ChevronDoubleLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M13.28 3.97a.75.75 0 010 1.06L6.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0zm6 0a.75.75 0 010 1.06L12.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(ChevronDoubleLeftIcon);
/* harmony default export */ var esm_ChevronDoubleLeftIcon = (ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/solid/esm/ChevronDoubleRightIcon.js


function ChevronDoubleRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.72 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L11.69 12 4.72 5.03a.75.75 0 010-1.06zm6 0a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06L17.69 12l-6.97-6.97a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}

const ChevronDoubleRightIcon_ForwardRef = react.forwardRef(ChevronDoubleRightIcon);
/* harmony default export */ var esm_ChevronDoubleRightIcon = (ChevronDoubleRightIcon_ForwardRef);
// EXTERNAL MODULE: ./config/config.ts
var config = __webpack_require__(60114);
;// CONCATENATED MODULE: ./components/JobPosts/JobPostsSearchAndResults/JobPostsResults/JobPostsPagination.tsx




const JobPostsPagination = (param)=>{
    let { totalHits , size =config/* ES_DEFAULT_QUERY_SIZE */.au , currentPage  } = param;
    const router = (0,next_router.useRouter)();
    const MAX_SIDE_STEPS = 3; // max number of steps to the left or right of the current page
    const totalPages = Math.min(Math.ceil(totalHits / size), config/* ES_MAX_QUERY_OFFSET */.yV / size + 1);
    const pages = [
        ...Array.from(Array(totalPages + 1).keys())
    ].splice(1); // creates 1-indexed array of page numbers
    const getPath = (pge)=>{
        // Remove segment props so they don't show in URLSearchParams
        const queryWithoutSegments = {
            ...router.query
        };
        delete queryWithoutSegments.slug1;
        delete queryWithoutSegments.slug2;
        delete queryWithoutSegments.slug3;
        // Add page to query
        // const query = { ...queryWithoutSegments, from: (page * size).toString() };
        const query = {
            ...queryWithoutSegments,
            page: pge.toString()
        };
        // Remove page param if it's the first page
        if (pge === 1) {
            delete query.page;
        }
        // Get clean route without params
        const route = router.asPath.split("?")[0];
        // Compose new path
        const isQueryEmpty = Object.keys(query).length === 0;
        const path = isQueryEmpty ? route : "".concat(route, "?").concat(new URLSearchParams(query).toString());
        return path;
    };
    return totalPages > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-center",
        children: [
            currentPage - MAX_SIDE_STEPS >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: getPath(1),
                title: "First page",
                className: "mr-1 px-1.5 py-2.5 text-xs uppercase hover:bg-gray-100 border border-transparent hover:border-gray-100 rounded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronDoubleLeftIcon, {
                    className: "inline h-4 -mt-0.5"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "",
                children: pages.filter((i)=>{
                    return i >= currentPage - MAX_SIDE_STEPS && i <= currentPage + MAX_SIDE_STEPS;
                }).map((i)=>i === currentPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "px-4 py-2 text-sm font-semibold text-white bg-black border border-black rounded",
                        children: i
                    }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: getPath(i),
                        className: "px-4 py-2 text-sm font-semibold hover:bg-gray-100 border border-transparent hover:border-gray-100 rounded",
                        children: i
                    }, i))
            }),
            currentPage + MAX_SIDE_STEPS < totalPages && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: getPath(totalPages),
                title: "Last page",
                className: "ml-1 px-1.5 py-2.5 text-xs uppercase hover:bg-gray-100 border border-transparent hover:border-gray-100 rounded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronDoubleRightIcon, {
                    className: "inline h-4 -mt-0.5"
                })
            })
        ]
    }) : null;
};

// EXTERNAL MODULE: ./utils/formatters/timeSinceFormatter.ts
var timeSinceFormatter = __webpack_require__(65997);
// EXTERNAL MODULE: ./components/EmailSubscriptionForm/EmailSubscriptionForm.tsx
var EmailSubscriptionForm = __webpack_require__(79691);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/JobPosts/RelatedPages.tsx


const RelatedPages = (param)=>{
    let { relatedPages  } = param;
    return (relatedPages === null || relatedPages === void 0 ? void 0 : relatedPages.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "space-y-2",
        children: relatedPages.map((relatedPage)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "list-disc ml-4 marker:text-gray-400",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: relatedPage.path,
                    className: "text-blue-600 hover:underline list-disc",
                    children: relatedPage.pageTitle
                })
            }, relatedPage.path))
    }) : null;
};

;// CONCATENATED MODULE: ./components/JobPosts/JobPostsSearchAndResults/JobPostsSearchAndResults.tsx







const JobPostsSearchAndResults = (param)=>{
    let { initialJobPostSearchParams , initialJobPosts , totalHits , initialNextCursor , relatedPages  } = param;
    var ref;
    const newestJobPostCreatedAt = (ref = initialJobPosts.filter((j)=>!j.isSticky)[0]) === null || ref === void 0 ? void 0 : ref.createdAt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "text-2xl font-bold",
                    children: [
                        "Search results",
                        initialJobPostSearchParams.page === 1 && newestJobPostCreatedAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "ml-4 text-base font-normal",
                            children: [
                                "Latest post about",
                                " ",
                                (0,timeSinceFormatter/* timeSinceFormatter */.H)(new Date(newestJobPostCreatedAt), {
                                    addSuffix: true
                                }),
                                "."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostsList, {
                jobPostSearchParams: initialJobPostSearchParams,
                jobPosts: initialJobPosts,
                initialNextCursor: initialNextCursor
            }),
            initialJobPosts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-10 mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostsPagination, {
                    totalHits: totalHits,
                    // from={initialJobPostSearchParams.from}
                    size: initialJobPostSearchParams.size,
                    currentPage: initialJobPostSearchParams.page
                })
            }),
            (relatedPages === null || relatedPages === void 0 ? void 0 : relatedPages.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-10 p-6 pt-4 border rounded-md ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-3 text-xl font-bold",
                        children: "Related searches"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedPages, {
                            relatedPages: relatedPages
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-10 p-6 pt-4 rounded-md bg-gray-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "mb-4 text-xl font-bold",
                        children: [
                            "Get ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "",
                                children: "new jobs"
                            }),
                            " in your inbox."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSubscriptionForm/* EmailSubscriptionForm */.$, {
                        defaultGroups: [
                            "69844943583053565"
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 60114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T$": function() { return /* binding */ ES_JOB_POST_INDEX_CURRENT_NAME; },
/* harmony export */   "au": function() { return /* binding */ ES_DEFAULT_QUERY_SIZE; },
/* harmony export */   "yV": function() { return /* binding */ ES_MAX_QUERY_OFFSET; }
/* harmony export */ });
/* unused harmony exports currentEnv, isProd, ES_MAX_DISTANCE_IN_KM, ES_MAX_AGE_IN_DAYS, ES_MAX_QUERY_SIZE, ES_BATCH_INDEXING_BATCH_SIZE, ES_BATCH_INDEXING_PAUSE_BETWEEN_BATCHES_IN_SECONDS, SCRAPER_PARSE_MAX_ITEMS, SCRAPER_SIMILARITY_THRESHOLD_FOR_DUPLICATES, ANALYTICS_INGESTION_INTERVAL_IN_MINUTES, ANALYTICS_NUMBER_OF_EVENTS_TO_INGEST_AT_ONCE, CURRENCY_UPDATE_EXCHANGE_RATES_INTERVAL_IN_MINUTES, TWITTER_JOB_POST_QUALITY_THRESHOLD, TWITTER_JOB_POST_MAX_AGE_IN_DAYS, TWITTER_JOB_POST_TWEET_TIMES, TWITTER_JOB_POST_TWEET_GENERAL_TAGS, SITEMAP_JOB_POST_APPROVED_AT_MAX_AGE_IN_DAYS, SITEMAP_JOB_POST_PRIORITY_DEFAULT, SITEMAP_JOB_POST_CHANGEFREQ_DEFAULT, SUPABASE_STORAGE_PUBLIC_BUCKET, SUPABASE_STORAGE_PUBLIC_BUCKET_ORGANISATION_PATH */
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83454);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(process__WEBPACK_IMPORTED_MODULE_0__);

// ENV
const currentEnv = "production";
const isProd = currentEnv === "production";
// -------------------------------------------------------------------------------------------
// ELASTIC SEARCH
const ES_JOB_POST_INDEX_VERSION = 1;
const ES_JOB_POST_INDEX_CURRENT_NAME = "job-post-".concat(ES_JOB_POST_INDEX_VERSION, "-").concat(process__WEBPACK_IMPORTED_MODULE_0__.env.ELASTIC_ENV_SCOPE);
const ES_MAX_DISTANCE_IN_KM = 500;
const ES_MAX_AGE_IN_DAYS = 60;
const ES_DEFAULT_QUERY_SIZE = 40;
const ES_MAX_QUERY_SIZE = 100;
const ES_MAX_QUERY_OFFSET = 1000;

// Batch indexing.
const ES_BATCH_INDEXING_BATCH_SIZE = 50;
const ES_BATCH_INDEXING_PAUSE_BETWEEN_BATCHES_IN_SECONDS = 2;
// -------------------------------------------------------------------------------------------
// SCAPER
const SCRAPER_PARSE_MAX_ITEMS = 3;
const SCRAPER_SIMILARITY_THRESHOLD_FOR_DUPLICATES = 0.98;
// -------------------------------------------------------------------------------------------
// ANALYTICS (internal)
const ANALYTICS_INGESTION_INTERVAL_IN_MINUTES = 2;
const ANALYTICS_NUMBER_OF_EVENTS_TO_INGEST_AT_ONCE = 50;
// -------------------------------------------------------------------------------------------
// CURRENCY
const CURRENCY_UPDATE_EXCHANGE_RATES_INTERVAL_IN_MINUTES = 1440; // 1 day
// -------------------------------------------------------------------------------------------
// QUALITY (tag)

// -------------------------------------------------------------------------------------------
// TWITTER
const TWITTER_JOB_POST_QUALITY_THRESHOLD = 60;
const TWITTER_JOB_POST_MAX_AGE_IN_DAYS = 3;
const TWITTER_JOB_POST_TWEET_TIMES = [
    "01:34",
    "05:32",
    "09:04",
    "11:56",
    "15:58",
    "20:34"
].sort(); // needs to be sorted from earliest to latest
const TWITTER_JOB_POST_TWEET_GENERAL_TAGS = (/* unused pure expression or super */ null && ([
    "javascript",
    "developer",
    "jobs",
    "job",
    "recruiting",
    "career",
    "js"
]));
// -------------------------------------------------------------------------------------------
// SITEMAP
const SITEMAP_JOB_POST_APPROVED_AT_MAX_AGE_IN_DAYS = 45;
const SITEMAP_JOB_POST_PRIORITY_DEFAULT = 0.5;
const SITEMAP_JOB_POST_CHANGEFREQ_DEFAULT = "weekly";
// -------------------------------------------------------------------------------------------
// SUPABASAE
const SUPABASE_STORAGE_PUBLIC_BUCKET = "public";
const SUPABASE_STORAGE_PUBLIC_BUCKET_ORGANISATION_PATH = "organisation/";


/***/ }),

/***/ 94156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23544);
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_JobPosts_JobPostsSearchAndResults_JobPostsSearchAndResults__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57743);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4828);




function Home(param) {
    let { jobPosts , totalHits , nextCursor , jobPostSearchParams  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* .Layout */ .A, {
        pageTitle: "Find JavaScript Jobs",
        hasSearch: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-4xl m-auto",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_JobPosts_JobPostsSearchAndResults_JobPostsSearchAndResults__WEBPACK_IMPORTED_MODULE_2__/* .JobPostsSearchAndResults */ .m, {
                initialJobPostSearchParams: jobPostSearchParams,
                initialJobPosts: jobPosts,
                totalHits: totalHits,
                initialNextCursor: nextCursor
            })
        })
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_1__.withSuperJSONPage)(Home));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,8184,3544,2804,5675,7536,815,7522,4828,7938,9774,2888,179], function() { return __webpack_exec__(8266); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);